module.exports = __webpack_public_path__ + "img/SE_Logo_White_RGB.040c29fc.png";